/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getAccessToken } from "@lib/shared/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";
import { getTrustedFormCertificateUrl } from "@lib/shared/certificateUtils";

interface FormSubmitApiBody {
    fields: { codeName: string; value: string }[];
    leadId: string | null;
    jornayaId: string | undefined;
    url?: string;
    submit: boolean;
    domainFormId: number | null;
    otpCode: string | undefined;
    fetchBuyers?: boolean;
    language: string;
    meta?: {
        [x: string]: string | number | boolean;
    };
    isPiiCompletionForm?: boolean;
    token?: string;
    buyerIds: (number | string)[];
    consentLanguage: string;
    isOneToOneConsent?: boolean;
    forcedBuyersIds?: number[] | null;
    excludedBuyers?: number[] | null;
}
export interface SubmitLeadFormResponse {
    success: boolean;
    data: {
        leadId: string | null;
        operationId?: string;
        otpRequired: boolean;
        otpTime: number | undefined;
        results?:
            | undefined
            | {
                  status: "rejected";
                  codeName: string;
                  reason: string;
                  errorCode: string;
              }[];
        enqueued?: boolean;
    } | null;
}

// export const submitLeadForm = async (
//     data: Partial<FormSubmitApiBody>,
// ): Promise<{
//     data: SubmitLeadFormResponse["data"] | null;
//     error: Error | null;
// }> => {
//     const accessToken = getAccessToken();

//     const {
//         fields,
//         leadId,
//         jornayaId,
//         url,
//         submit,
//         domainFormId,
//         otpCode,
//         language,
//         meta,
//         fetchBuyers,
//         forcedBuyersIds,
//         excludedBuyers,
//     } = data;

//     console.log("data==>", data);

//     const trustedFormCertificateUrl: string =
//         //@ts-ignore
//         document.getElementById("TrustedFormCertUrl_0")?.value;

//     console.log("trustedFormCertificateUrl==>", trustedFormCertificateUrl);

//     const config: AxiosRequestConfig = {
//         method: "post",
//         url: `/api/submitLeadForm`,
//         data: {
//             fields,
//             leadId: leadId ?? undefined,
//             jornayaId: jornayaId ? jornayaId : undefined,
//             url: url ?? window.location.href,
//             submit,
//             domainFormId: domainFormId ?? undefined,
//             trustedFormCertificateUrl: trustedFormCertificateUrl
//                 ? trustedFormCertificateUrl
//                 : undefined,
//             otpCode,
//             language,
//             meta,
//             fetchBuyers,
//             forcedBuyersIds,
//             isPiiCompletionForm: data.isPiiCompletionForm ?? false,
//             token: data.isPiiCompletionForm ? data.token : undefined,
//             buyerIds: data.buyerIds,
//             consentLanguage: data.consentLanguage,
//             isOneToOneConsent: data.isOneToOneConsent ?? false,
//             excludedBuyers,
//         },
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken as string}`,
//         },
//     };

//     const { data: submitLeadFormResponse, error } =
//         await apiHandler<SubmitLeadFormResponse>(() => HTTP.client(config));

//     return {
//         data: submitLeadFormResponse?.data ?? null,
//         error,
//     };
// };

export const submitLeadForm = async (
    data: Partial<FormSubmitApiBody>,
): Promise<{
    data: SubmitLeadFormResponse["data"] | null;
    error: Error | null;
}> => {
    const accessToken = getAccessToken();

    const {
        fields,
        leadId,
        jornayaId,
        url,
        submit,
        domainFormId,
        otpCode,
        language,
        meta,
        fetchBuyers,
        forcedBuyersIds,
        excludedBuyers,
    } = data;

    // // Utility: Wait for TrustedForm certificate (max 3 retries)
    // const getTrustedFormCertificateUrl = (
    //     attempt = 1,
    // ): Promise<string | null> => {
    //     return new Promise((resolve) => {
    //         const trustedFormHiddenElement = document.getElementById(
    //             "TrustedFormCertUrl_0",
    //         ) as HTMLInputElement | null;

    //         if (trustedFormHiddenElement && trustedFormHiddenElement.value) {
    //             resolve(trustedFormHiddenElement.value);
    //         } else if (attempt <= MAX_TRUSTED_FORM_RETRIES) {
    //             setTimeout(() => {
    //                 resolve(getTrustedFormCertificateUrl(attempt + 1));
    //             }, TRUSTED_FORM_RETRY_DELAY_MS);
    //         } else {
    //             resolve(null);
    //         }
    //     });
    // };

    let trustedFormCertificateUrl: string | null | undefined = undefined;
    if (excludedBuyers && excludedBuyers.length) {
        // Wait until TrustedForm is ready or fallback resolves
        trustedFormCertificateUrl = await getTrustedFormCertificateUrl();
    } else {
        trustedFormCertificateUrl = (
            document.getElementById("TrustedFormCertUrl_0") as HTMLInputElement
        )?.value;
    }

    const config: AxiosRequestConfig = {
        method: "post",
        url: `/api/submitLeadForm`,
        data: {
            fields,
            leadId: leadId ?? undefined,
            jornayaId: jornayaId ? jornayaId : undefined,
            url: url ?? window.location.href,
            submit,
            domainFormId: domainFormId ?? undefined,
            trustedFormCertificateUrl: trustedFormCertificateUrl
                ? trustedFormCertificateUrl
                : undefined,
            otpCode,
            language,
            meta,
            fetchBuyers,
            forcedBuyersIds,
            isPiiCompletionForm: data.isPiiCompletionForm ?? false,
            token: data.isPiiCompletionForm ? data.token : undefined,
            buyerIds: data.buyerIds,
            consentLanguage: data.consentLanguage,
            isOneToOneConsent: data.isOneToOneConsent ?? false,
            excludedBuyers,
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken as string}`,
        },
    };

    const { data: submitLeadFormResponse, error } =
        await apiHandler<SubmitLeadFormResponse>(() => HTTP.client(config));

    return {
        data: submitLeadFormResponse?.data ?? null,
        error,
    };
};
